import * as React from 'react';
import PortalIdParser from 'PortalIdParser';
import { useQuery } from 'data-fetching-client';
import { FETCH_PROPERTY_SOURCE } from 'flow-doctor-lib/queries/PropertySourceQueries';
import SkeletonText from 'flow-doctor-lib/components/common/SkeletonText';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIAccordionItem from 'UIComponents/accordion/UIAccordionItem';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import UILink from 'UIComponents/link/UILink';
import { getAppUrlForRelativeUri } from 'flow-doctor-lib/utils/urls';
import { ContactsIcon } from 'foundations-assets';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const getInstanceLabel = instance => {
  if (!instance) {
    return null;
  }
  return instance.relativeUri ? /*#__PURE__*/_jsx(UILink, {
    href: getAppUrlForRelativeUri(instance.relativeUri),
    external: true,
    children: instance.name
  }) : instance.name;
};
const getUserLabel = user => {
  if (!user) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(View, {
      as: "span",
      marginInlineEnd: "100",
      children: /*#__PURE__*/_jsx(ContactsIcon, {})
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "flow-doctor-lib.flows.objectLifecycle.sourceUpdatedBy",
      options: {
        userName: user.displayResult
      }
    })]
  });
};
const PropertySourceLabel = ({
  source,
  sourceId,
  defaultOpen = false
}) => {
  const {
    data,
    loading,
    error
  } = useQuery(FETCH_PROPERTY_SOURCE, {
    variables: {
      portalId: PortalIdParser.get(),
      propertySource: source,
      sourceId
    }
  });
  if (!error && (loading || !data)) {
    return /*#__PURE__*/_jsx(SkeletonText, {
      width: 200
    });
  }
  const sourceLabel = /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "flow-doctor-lib.flows.objectLifecycle.source",
    options: {
      sourceLabel: data ? data.fetchPropertySource.label : source
    }
  });
  if (!data) {
    return sourceLabel;
  }
  const sourceInfo = data.fetchPropertySource;
  const sourceLabelWithDescription = /*#__PURE__*/_jsxs(_Fragment, {
    children: [sourceInfo.description && /*#__PURE__*/_jsx(UIHelpIcon, {
      className: "m-right-1",
      title: sourceInfo.description
    }), sourceLabel]
  });
  if (sourceInfo.instance || sourceInfo.user) {
    const instanceLabel = getInstanceLabel(sourceInfo.instance);
    const userLabel = getUserLabel(sourceInfo.user);
    return /*#__PURE__*/_jsxs(UIAccordionItem, {
      flush: true,
      defaultOpen: defaultOpen,
      title: sourceLabelWithDescription,
      isCardHeader: true,
      children: [userLabel, instanceLabel]
    });
  }
  return sourceLabelWithDescription;
};
export default PropertySourceLabel;